import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closePaymentModal,
  openPaymentMethod,
} from "../../../features/slices/ModalSlice";
import newChatIcon from "../../../assets/images/newChatIcon.png";
import PaymentMethodSlider from "./PaymentMethodSlider";
import {
  initiateDepositIntent,
  reset,
} from "../../../features/slices/PaymentSlice";
import { useMediaQuery } from "react-responsive";
import {
  showChatBoxInDesktop,
  updateSelectedItem,
} from "../../../features/slices/CommonSlice";
import ErrorCard from "../../common/ErrorCard";

export default function DepositContent() {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();
  const amountOptions = [
    {
      amount: "500",
      id: "amount1",
    },
    {
      amount: "1,000",
      id: "amount2",
    },
    {
      amount: "5,000",
      id: "amount3",
    },
    {
      amount: "10,000",
      id: "amount4",
    },
    {
      amount: "50,000",
      id: "amount5",
    },
  ];
  const modal = useSelector((state) => state.modal);
  const payment = useSelector((state) => state.payment);
  const [selectedAmount, setSelectedAmount] = useState("amount1");
  const [enteredAmount, setAmount] = useState("0");
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [nextStep, getNextStep] = useState("");
  const [paymentId, setPaymentId] = useState(null);
  // const [offerCode, setOfferCode] = useState(null);
  const [redBorder, setRedBorder] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
  const [gatewayMessage, setGatewayMessage] = useState("");

  const selectMethod = (payment_id) => {
    const selectedMethod = payment.paymentMethods.find(
      (item) => item.id === payment_id
    );
    if (!selectedMethod) return;

    setPaymentId(payment_id);
    setGatewayMessage("");
    getNextStep(
      selectedMethod.isManualPayment ? selectedMethod.stepKey : ""
    );
    setSelectedPaymentMethod(selectedMethod);
  };

  const addCommaInAmmount = (amount) => {
    return (
      parseInt(amount.toString().replace(/[^\d]+/gi, "")) || ""
    ).toLocaleString("en-US");
  };
  const handleAmountSelect = (amount) => {
    const prevAmount = +enteredAmount.replace(/,/g, "");
    const newAmount = +amount.replace(/,/g, "");
    const addedAMount = prevAmount + newAmount;
    let finalAmount = addCommaInAmmount(addedAMount);
    if (finalAmount.length === 7) {
      finalAmount = finalAmount.slice(0, 1) + "," + finalAmount.slice(1);
    }
    setAmount(finalAmount);
  };
  const handleSelectedOffer = (offerId) => {
    setSelectedOffer((prev) => (prev === offerId ? null : offerId));
  };
  const goToNextStep = () => {
    // dispatch(closePaymentModal());
    if (!selectedPaymentMethod.id) return;

    if (
      !enteredAmount ||
      +enteredAmount.replace(/,/g, "") <
        +selectedPaymentMethod.minAmonut.replace(/,/g, "") ||
      +enteredAmount.replace(/,/g, "") >
        +selectedPaymentMethod.maxAmonut.replace(/,/g, "")
    ) {
      setRedBorder(true);
      if (isMobile) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      return;
    }
    setRedBorder(false);
    setGatewayMessage("");
    dispatch(
      reset({
        amount: enteredAmount,
        amountId: selectedAmount,
      })
    );

    // AUTO / gateway methods are not wired yet — do not call createDepositRequest.
    if (!selectedPaymentMethod.isManualPayment) {
      setGatewayMessage("This gateway is not implemented");
      return;
    }

    // Deposit modal only has screens for UPI and IMPS.
    const manualStep =
      nextStep === "UPI" || nextStep === "IMPS" ? nextStep : "UPI";

    const selectedBonus = payment.bonusOffers.find(
      (offer) => offer.id === selectedOffer
    );
    dispatch(
      openPaymentMethod({
        nextStep: manualStep,
        amount: enteredAmount,
        paymentMethodId: paymentId,
        bonusTemplateId: selectedBonus?.templateId || "",
        // offerCode: null,
      })
    );
  };

  useEffect(() => {
    if (payment.selectedAmount?.amount) {
      setAmount(payment.selectedAmount.amount);
      setSelectedAmount(payment.selectedAmount.amountId);
    }
  }, [payment.selectedAmount]);

  const setEnteredAmount = (event) => {
    let amount = addCommaInAmmount(event.target.value);
    if (amount.length === 7) {
      amount = amount.slice(0, 1) + "," + amount.slice(1);
    }
    setAmount(amount);
    setRedBorder(false);
  };

  useEffect(() => {
    if (!modal.depositData?.paymentMethodId) return;

    const selectedMethod = payment.paymentMethods.find(
      (item) => item.id === modal.depositData.paymentMethodId
    );
    if (!selectedMethod) return;

    setPaymentId(selectedMethod.id);
    getNextStep(
      selectedMethod.isManualPayment ? selectedMethod.stepKey : ""
    );
    setSelectedPaymentMethod(selectedMethod);
  }, [modal.depositData, payment.paymentMethods]);

  // record the deposit intent as soon as the screen opens with a method
  // selected (amount falls back to the method's minimum until the player types
  // one), and again (debounced) whenever the amount or method changes
  useEffect(() => {
    if (!paymentId || !selectedPaymentMethod.id) return;
    const amount =
      +enteredAmount.replace(/,/g, "") ||
      +String(selectedPaymentMethod.minAmonut || "").replace(/,/g, "");
    if (!amount) return;

    const timer = setTimeout(() => {
      dispatch(initiateDepositIntent({ amount, paymentMethodId: paymentId }));
    }, 600);
    return () => clearTimeout(timer);
  }, [enteredAmount, paymentId, selectedPaymentMethod, dispatch]);

  const showChatBox = () => {
    if (isMobile) {
      dispatch(updateSelectedItem("chat-bot"));
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else dispatch(showChatBoxInDesktop());
    dispatch(closePaymentModal());
  };

  useEffect(() => {
    if (!payment.paymentMethods.length) return;

    const activePaymentMethods = payment.paymentMethods.filter(
      (item) => item.status
    );
    if (!activePaymentMethods.length) return;

    const firstMethod = activePaymentMethods[0];
    setSelectedPaymentMethod(firstMethod);
    setPaymentId(firstMethod.id);
    getNextStep(firstMethod.isManualPayment ? firstMethod.stepKey : "");
  }, [payment.paymentMethods]);

  return (
    <div className="row">
      <div className="col-md-6 col-lg-6 col-xl-6 col-12 deposit-col1 pt-4 pb-4">
        <div className="payment-options px-4">
          <PaymentMethodSlider
            methods={payment.paymentMethods}
            selectedId={paymentId}
            onSelect={selectMethod}
          />
        </div>
        <div className="amount-input mt-3 px-4">
          <label className="text--normal" style={{ fontWeight: "200" }}>
            Amount <span aria-hidden="true" className="required-asterisk">*</span>
          </label>
          <div className="d-flex">
            <input
              type="text"
              placeholder="Enter Amount"
              pattern="^[\d,]+$"
              className={redBorder ? "red-border" : ""}
              value={enteredAmount}
              onChange={(e) => {
                setEnteredAmount(e);
              }}
            />
            <span style={{ float: "right" }}>INR</span>
          </div>

          <p className="low-opacity text--small mb-0 mt-1">
            {selectedPaymentMethod.minAmonut +
              "-" +
              selectedPaymentMethod.maxAmonut}
          </p>
        </div>
        <div className="amount-options mt-3 px-4">
          <div className="d-flex">
            {amountOptions.map((item, index) => (
              <button
                key={index}
                className="text-center amount"
                id={item.id}
                onClick={() => handleAmountSelect(item.amount)}
              >
                +{item.amount}
              </button>
            ))}
          </div>
        </div>

        {!!payment.paymentMethods.length && selectedPaymentMethod.id && (
          <div className="px-4">
            <p
              className="low-opacity text--small mb-0 mt-1"
              style={{ color: "#E42D2D" }}
            >
              {+enteredAmount.replace(/,/g, "") <
              +selectedPaymentMethod.minAmonut.replace(/,/g, "")
                ? `Amount can't be less than ${selectedPaymentMethod.minAmonut}`
                : +enteredAmount.replace(/,/g, "") >
                  +selectedPaymentMethod.maxAmonut.replace(/,/g, "")
                ? `Amount can't be greater than ${selectedPaymentMethod.maxAmonut}`
                : ""}
            </p>
          </div>
        )}
        {!!payment.bonusOffers.length && (
          <div className="available-offers-container mt-3">
            <label className="text--small">Available Offers</label>
            <div className="available-offers">
              {payment.bonusOffers.map((offer) => (
                <div
                  key={offer.id}
                  className={`offer-card mt-2 mb-2 ${
                    selectedOffer === offer.id ? "active-offer" : ""
                  }`}
                  onClick={() => handleSelectedOffer(offer.id)}
                >
                  <p className=" text--medium mb-0">
                    {offer.displayName}
                  </p>
                  <p className="mb-0 text--normal offer-detail">
                    {offer.description}
                  </p>
                  <p
                    className="mb-0"
                    style={{
                      color: "#31B3FF",
                      fontSize: "10px",
                      opacity: "0.85",
                    }}
                  >
                    Terms & Conditions
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="col-md-6 col-lg-6 col-xl-6 col-12 deposit-col2">
        <div
          className="mt-3 px-3"
          style={{ borderBottom: "1px solid #707070", paddingBottom: "7px" }}
        >
          <p
            className="text--normal payment-detail"
            style={{ color: "#F5CA3D" }}
          >
            Payment Details
          </p>
          <div>
            <span className="text--normal mb-0">Amount</span>
            <span
              className="text--normal phone-amount-font"
              style={{ float: "right" }}
            >
              {enteredAmount || "00.00"} INR
            </span>
          </div>
          <div className="mt-1">
            <span className="text--normal mb-0">Bonus Offer</span>
            <span
              className="text--normal phone-amount-font"
              style={{ float: "right" }}
            >
              0.00 INR
            </span>
          </div>
        </div>
        <div className="px-3 mt-1">
          <span className="text--normal mb-0">Total Amount</span>
          <span
            className="text--normal phone-amount-font"
            style={{ float: "right" }}
          >
            {enteredAmount || "0.00"} INR
          </span>
        </div>
        <div className="mt-3 px-3 mobile-spacing">
          <p
            className="mb-0"
            style={{ fontWeight: "200", fontSize: "12px", opacity: "0.75" }}
          >
            Note:
          </p>
          <p
            className="text--normal"
            style={{ color: "#F5CA3D", fontWeight: "300", opacity: "0.75" }}
          >
            Bonus amount can be withdrawn only after 2X wagering
          </p>
        </div>
        <div className="action-btns px-3">
          {gatewayMessage ? <ErrorCard error={gatewayMessage} /> : null}
          {/* <p className="text-center text--medium statement">
            Problem in making payment please contact customer support
          </p> */}
          <div className="d-flex justify-content-between">
            <button
              className="border-btn"
              style={{ color: "#F5CA3D", border: "1px solid #F5CA3D" }}
              onClick={showChatBox}
            >
              <img
                loading="lazy"
                src={newChatIcon}
                alt="logo"
                className="mx-1"
                width={isMobile ? 25 : 30}
              />
              Chat with us
            </button>
            <button className="standard-btn" onClick={goToNextStep}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
